import React, { useContext, useEffect, useState } from "react";
import "./FirstTab1.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import JobCategory from "../../../../CommonPage/Home/JobCategory/JobCategory";
import ExploreOpportunity from "../../ExploreOpportunity/ExploreOpportunity";
import JobAlert from "../../JobAlert/JobAlert";
import { Context } from "../../../../../utils/context";
import { useNavigate } from "react-router-dom";

const FirstTab1 = () => {
  const { getData, imageUrl, postData, BarAnimations, NoDataAnimations } =
    useContext(Context);

  const navigate = useNavigate();

  const [suggestion, setSuggestion] = useState([]);
  const [company, setCompany] = useState([]);
  const [jobAlerts, setJobAlerts] = useState([]);

  const getAllData = async () => {
    try {
      const resSuggestion = await getData("/jobseeker/dashboard/suggestions");
      setSuggestion(resSuggestion?.data || []);

      const resCompany = await getData("/jobseeker/dashboard/follow");
      setCompany(resCompany?.data || []);

      const resAlerts = await getData("/jobseeker/dashboard/job-alerts");
      setJobAlerts(resAlerts?.data || []);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const Follow = async (company_id) => {
    try {
      await postData("/jobseeker/dashboard/follow", { company_id });
      getAllData();
    } catch (error) {
      console.error("Error following company:", error);
    }
  };

  const unFollow = async (company_id) => {
    try {
      await postData("/jobseeker/dashboard/unfollow", { company_id });
      getAllData();
    } catch (error) {
      console.error("Error unfollowing company:", error);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  // Helper calculation to securely count vacancies
  const getVacancyCount = (companyObj) => {
    return (
      companyObj?.pool_subscribers
        ?.map((data) => Number(data?.no_of_jobs))
        ?.reduce((acc, currentValue) => acc + (currentValue || 0), 0) || 0
    );
  };

  return (
    <>
      {/* Desktop / Tablet Layout */}
      <section className="FirstTabafterSignup dashboard-clean-sec d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-7">
              <Tabs className="row">
                <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2 mt-3">
                  <h2 className="Jobtabheading m-0">Companies You Followed</h2>
                  <TabList className="Job_grid-tab custom-tab-list m-0">
                    <Tab>
                      <FontAwesomeIcon icon="fa-solid fa-list-ul" />
                    </Tab>
                    <Tab>
                      <FontAwesomeIcon icon="fa-solid fa-border-all" />
                    </Tab>
                  </TabList>
                </div>

                {/* List View Tab Panel */}
                <TabPanel>
                  <div className="FirstTabafterSignup_card_main">
                    {company?.map((val, index) => {
                      const totalVacancies = getVacancyCount(val?.company);
                      return (
                        <div className="modern-company-card list-layout mb-3" key={index}>
                          <div className="card-logo-wrapper">
                            <img
                              src={imageUrl + val?.company?.image}
                              className="modern-company-logo"
                              alt={val?.company?.name}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          </div>
                          <div className="card-details-wrapper">
                            <div>
                              <h4 className="modern-company-title">{val?.company?.name}</h4>
                              <div className="job-types-tags mt-2">
                                <span className="badge-tag full-time">Full Time</span>
                                <span className="badge-tag part-time">Part Time</span>
                                <span className="badge-tag freelance">Freelance</span>
                              </div>
                            </div>
                            <div className="card-actions-wrapper">
                              <button
                                className={`modern-vacancy-btn ${
                                  totalVacancies > 0 ? "has-jobs" : "no-jobs"
                                }`}
                                onClick={() =>
                                  totalVacancies > 0 &&
                                  navigate("/", {
                                    state: { company_name: val?.company?.name },
                                  })
                                }
                              >
                                {totalVacancies} {totalVacancies === 1 ? "Vacancy" : "Vacancies"}
                              </button>
                              <button
                                className="modern-unfollow-btn"
                                onClick={() => unFollow(val?.company_id)}
                              >
                                Unfollow
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {company?.length === 0 && <NoDataAnimations />}
                  </div>
                </TabPanel>

                {/* Grid View Tab Panel */}
                <TabPanel>
                  <div className="FirstTabafterSignup_card_main">
                    <div className="row g-3">
                      {company?.map((val, index) => {
                        const totalVacancies = getVacancyCount(val?.company);
                        return (
                          <div className="col-xl-4 col-md-6" key={index}>
                            <div className="modern-company-card grid-layout text-center h-100">
                              <div className="card-logo-wrapper mx-auto mb-3">
                                <img
                                  src={imageUrl + val?.company?.image}
                                  className="modern-company-logo"
                                  alt={val?.company?.name}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                  }}
                                />
                              </div>
                              <h4 className="modern-company-title text-truncate px-2">
                                {val?.company?.name}
                              </h4>

                              <div className="mt-auto pt-3">
                                <button
                                  className={`modern-vacancy-btn w-100 mb-2 ${
                                    totalVacancies > 0 ? "has-jobs" : "no-jobs"
                                  }`}
                                  onClick={() =>
                                    totalVacancies > 0 &&
                                    navigate("/", {
                                      state: { company_name: val?.company?.name },
                                    })
                                  }
                                >
                                  {totalVacancies} {totalVacancies === 1 ? "Vacancy" : "Vacancies"}
                                </button>
                                <button
                                  className="modern-unfollow-btn d-block mx-auto"
                                  onClick={() => unFollow(val?.company_id)}
                                >
                                  Unfollow Company
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {company?.length === 0 && <NoDataAnimations />}
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>

            {/* Sidebar Suggestions Column */}
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-5 mt-4 mt-md-0">
              <h3 className="Suggestions_heading mb-4">Suggestions for You</h3>
              <div className="modern-suggestion-card">
                {suggestion?.map((data, index) => (
                  <div className="suggestion-item-row" key={index}>
                    <div className="d-flex align-items-center gap-3">
                      <div className="suggestion-logo-box">
                        <img
                          src={imageUrl + data?.image}
                          alt=""
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      </div>
                      <div>
                        <h5 className="suggestion-name m-0 text-truncate">{data?.name}</h5>
                        <p className="suggestion-meta m-0">
                          <FontAwesomeIcon icon="fa-solid fa-location-dot" className="me-1" />
                          {data?.city?.name || "Pune"}
                        </p>
                      </div>
                    </div>
                    <button className="modern-follow-btn" onClick={() => Follow(data?.id)}>
                      Follow
                    </button>
                  </div>
                ))}
                {suggestion?.length === 0 && <BarAnimations />}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modern Clean Mobile View */}
      <section className="mobile_FirstTabafterSignup m-3 d-block d-md-none">
        <Tabs>
          <TabList className="custom-tab-list w-100 d-flex mb-4">
            <Tab className="mobile_first_tab_companies flex-grow-1 text-center">Followed</Tab>
            <Tab className="mobile_first_tab_companies flex-grow-1 text-center">Suggestions</Tab>
          </TabList>

          {/* Mobile Followed Companies */}
          <TabPanel>
            <div className="FirstTabafterSignup_card_main">
              {company?.map((val, index) => {
                const totalVacancies = getVacancyCount(val?.company);
                return (
                  <div className="modern-company-card mb-3" key={index}>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="card-logo-wrapper">
                        <img
                          src={imageUrl + val?.company?.image}
                          className="modern-company-logo"
                          alt=""
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      </div>
                      <h4 className="modern-company-title text-truncate">{val?.company?.name}</h4>
                    </div>

                    <div className="d-flex align-items-center justify-content-between pt-2 border-top">
                      <button
                        className={`modern-vacancy-btn py-1 px-3 ${
                          totalVacancies > 0 ? "has-jobs" : "no-jobs"
                        }`}
                        onClick={() =>
                          totalVacancies > 0 &&
                          navigate("/", {
                            state: { company_name: val?.company?.name },
                          })
                        }
                      >
                        {totalVacancies} Vacancies
                      </button>
                      <button
                        className="modern-unfollow-btn text-danger fw-semibold"
                        onClick={() => unFollow(val?.company_id)}
                      >
                        Unfollow
                      </button>
                    </div>
                  </div>
                );
              })}
              {company?.length === 0 && <NoDataAnimations />}
            </div>
          </TabPanel>

          {/* Mobile Suggestions */}
          <TabPanel>
            <div className="modern-suggestion-card">
              {suggestion?.map((data, index) => (
                <div className="suggestion-item-row" key={index}>
                  <div className="d-flex align-items-center gap-3">
                    <div className="suggestion-logo-box">
                      <img
                        src={imageUrl + data?.image}
                        alt=""
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                    </div>
                    <div>
                      <h5 className="suggestion-name m-0">{data?.name}</h5>
                      <p className="suggestion-meta m-0">
                        <FontAwesomeIcon icon="fa-solid fa-location-dot" className="me-1" />
                        {data?.city?.name || "Pune"}
                      </p>
                    </div>
                  </div>
                  <button className="modern-follow-btn" onClick={() => Follow(data?.id)}>
                    Follow
                  </button>
                </div>
              ))}
              {suggestion?.length === 0 && <BarAnimations />}
            </div>
          </TabPanel>
        </Tabs>

        <div className="mt-4">
          <JobCategory />
          <JobAlert />
          <ExploreOpportunity />
        </div>
      </section>
    </>
  );
};

export default FirstTab1;